import styled from "styled-components";
import css from "@styled-system/css";
import { Button as StreamButton } from "../guide/Stream/styled";
import { Card as InfoCard, Title as InfoTitle } from "./InfoCard";

export const Title = styled(InfoTitle)(
  css({
    fontSize: [3, 4],
    fontWeight: "bold",
    mb: 30,
  })
);

export const Button = styled(StreamButton)(
  css({
    fontSize: [2, 3],
    my: 0,
    width: "100%",
    boxSizing: "border-box",
  })
);

export const Card = styled(InfoCard)({
  display: "flex",
  flexDirection: "column",
  "> :first-child": {
    flexGrow: 1,
  },
});
